import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from 'react-redux';
import {withRouter, Link} from 'react-router-dom';
import ReactHighcharts from 'react-highcharts';
import 'react-data-components/css/table-twbs.css';
import PeopleStudentsContainer from '../../../containers/AdminPanel/People/PeopleStudentsContainer';
import moment from 'moment';

class CourseStatistic extends Component {


    constructor(props){
        super(props);

        this.state = {
            columns: (this.props.usersStatus.columnsTable) ? [...this.props.usersStatus.columnsTable] : [],
            displayColumns: [{title: 'Name',
                prop: 'name'},
                {title: 'Status', prop: 'status'},
                {title: 'Start date', prop: 'created'},
                {title: 'Last active', prop: 'last_active'},
                {title: 'Avg S. Time', prop: 'avgstime'},
                {title: 'Test Date', prop: 'testdate'},
                {title: 'Options', prop: 'options'}
            ],
            columnsTable: [],
            chart: [],
            chartType: 'main',
            dateRange: 365,
            chartSubject: null,
            chartX: [],
            testChartX: [],
            chartLegend: false,
            testChart: []
        };
    }

    //Renders
    renderLinks = (name) => (
        <li>
            <a >
                {name}
            </a>
        </li>
    );

    renderOptions = () => (
        <div className="dropdown">
            <a
                role="button"
                data-toggle="dropdown"
                className="btn btn-default"
            >
                Options
            </a>
            <ul className="dropdown-menu">
                {this.renderLinks('Go to messenger')}
                {this.renderLinks('Send Notification')}
                {this.renderLinks('Friends')}
                {this.renderLinks('Recommend Friend')}
                {this.renderLinks('Change Status')}
            </ul>
        </div>
    );

    renderCheckbox = () => (
        this.state.columnsTable.map((item, index) => (
            <li key={index}>
                <label>
                    <input
                        type="checkbox"
                        value={index}
                        defaultChecked={item.defaultChecked}
                        onChange={this.handleChangeInput}
                    />
                    {item.title}
                </label>
            </li>
        ))
    );

    renderTableButton = (button, name) => (
        <button
            className={"btn btn-default buttons-html5 buttons-"+button }
            tabIndex="0"
            aria-controls="DataTables_Table_0"
        >
            <span>{name}</span>
        </button>
    );

    renderControlsForTable = () => (
        <div className="border-bottom sp-10">
            <div className="clearfix">
                <div className="pull-left">
                    <div className="btn-group">
                        <div className="dropdown">
                            <a
                                role="button"
                                data-toggle="dropdown"
                                className="btn btn-default"
                            >
                                Show/Hide Columns
                            </a>
                            <ul className="dropdown-menu showHidColumns">
                                {this.renderCheckbox()}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="pull-right">
                    <div className="dt-buttons btn-group">
                        {this.renderTableButton('copy', 'Copy')}
                        {this.renderTableButton('excel', 'Excel')}
                        {this.renderTableButton('pdf', 'PDF')}
                    </div>
                </div>
            </div>
        </div>
    );

    renderConfigHighchart = (statisticDiagram) => {
        let yName = 'Class Average';
        switch(this.state.chartType){
            case 'subject':
                yName = 'Subject Performance';
                break;
            case 'quiz':
                yName = 'Quiz Performance';
                break;
            default:
                yName = 'Class Average';
                break;
        }
        let self = this;
        return (
            {
                chart: {
                    type: 'column',
                    backgroundColor: {
                        linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                        stops: [
                            [0, '#333'],
                            [1, '#333']
                        ]
                    }
                },
                legend: true,
                yAxis: {
                    min: 0,
                    max: 100,
                    title: {
                        text: yName
                    }
                },
                xAxis: {
                    categories: this.props.chartX
                },
                plotOptions: {
                    column: {
                        pointPadding: 0.2,
                        borderWidth: 0,
                        events: {
                            click: function (e) {

                                    self.buildTestChart(e.point);

                                //$("#SubjectQuestionGraph").modal("show");
                                //ShowSubjectQuestionGraph();
                            }
                        }
                    }
                },
                series: statisticDiagram

            }
        )
    };

    renderQuizHighchart = (chartData) => {
        return (
            {
                chart: {
                    type: 'column',
                    backgroundColor: {
                        linearGradient: {x1: 0, y1: 0, x2: 1, y2: 1},
                        stops: [
                            [0, '#333'],
                            [1, '#333']
                        ]
                    }
                },
                title: false,
                xAxis: {
                    categories: this.state.testChartX
                },
                yAxis: {
                    min: 0,
                    max: 100,
                    title: {
                        text: 'Percentage correct'
                    },
                    gridLineColor: '#3a3a3a',
                    stackLabels: {
                        enabled: false
                    }
                },
                /*legend: {
                    align: 'right',
                    x: -30,
                    verticalAlign: 'top',
                    y: 25,
                    floating: true,
                    backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
                    borderColor: '#CCC',
                    borderWidth: 1,
                    shadow: false
                },*/
                legend: false,
                tooltip: {
                    headerFormat: '<b>{point.x}</b><br/>',
                    pointFormat: '{series.name}: {point.y}%<br/>Total: {point.stackTotal}%'
                },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true,
                            format: '{point.y}%'
                        }

                    }
                },
                series: chartData
            }
        )
    }

    buildTestChart = (ChapterVideo) => {
        let {testChart, testChartX} = this.state;

        let tests = [];

        this.props.course.CourseSubject.map(s => {
            s.CourseChapter.map(c =>{
                c.ChapterVideo.map(v => {
                    if(v.id === ChapterVideo.id){
                        tests = v.ChapterTest;
                    }
                })
            })
        })

        testChartX = [];

        testChart = [
            {
                name: 'Correct',
                data: []
            },
            {
                name: 'Incorrect',
                data: []
            }
        ]


        tests.map((test, i) => {
            test.answers.map((a, ai) => {
                if(!testChartX[ai]){
                    testChartX[ai] = "Q" + (ai + 1).toString();
                    if(a.correct){
                        if(testChart[0].data[ai]){
                            testChart[0].data[ai] += 1;
                        }else{
                            testChart[0].data[ai] = 1;
                        }
                    }else{
                        if(testChart[1].data[ai]){
                            testChart[1].data[ai] += 1;
                        }else{
                            testChart[1].data[ai] = 1;
                        }
                    }
                }
            })

        })

        let FinalChart = [
            {
                name: 'Correct',
                data: []
            },
            {
                name: 'Incorrect',
                data: []
            }
        ]

        testChart[0].data.map((val, index) => {
            if(testChart[1].data[index]){
                let total = val + testChart[1].data[index];
                let correctPercent = parseInt(parseFloat((val / total) * 100));
                FinalChart[0].data[index] = correctPercent;
                FinalChart[1].data[index] = 100 - correctPercent;
            }else{
                FinalChart[0].data[index] = 100;
                FinalChart[1].data[index] = 0;
            }
        })

        this.setState({testChart: FinalChart, testChartX, showTestDetails: true});
    }

    //Actions
    handleChangeInput = (event) => {

        if (event.target.checked) {
            let val = this.state.displayColumns.find(item => item.value > +event.target.value);

            if (val){
                this.state.displayColumns.map((item, index) => {
                    if (item.value === val.value) {
                        return val = index;
                    }
                    return val;
                });
            } else {
                val = event.target.value;
            }

            this.state.displayColumns.splice(val, 0,  this.state.columnsTable[event.target.value]);
            this.setState({displayColumns: this.state.displayColumns});

        } else {
            this.state.displayColumns.map((item, index) => {
                if(item.value === +event.target.value) {
                    this.state.displayColumns.splice(index, 1 );
                    this.setState({displayColumns: this.state.displayColumns});
                }
                return item
            });
        }
    };

    updateChartType = (type, option) => {
        let {chartSubject} = this.state;

        if(type === "subject"){
            chartSubject = option;
        }else{
            chartSubject = null;
        }

        this.setState({chartType: type, chartSubject}, () => {
            this.buildChart(type, this.props.course, '');
        })
    }

    updateChartDate = (d) => {
        let r = 365;
        switch(d){
            case '12 Months':
                r = 365;
                break;
            case '6 Months':
                r = 183;
                break;
            case '3 Months':
                r = 90;
                break;
            case '1 Month':
                r = 30;
                break;
            case '15 Days':
                r = 15;
                break;
            default:
                r = 365;
                break;
            }

        this.setState({dateRange: r}, () => {
            this.buildChart(this.state.chartType, this.props.course, '');
        })
    }

    buildChart = (type, course, option) => {

        let {chart, chartType, chartX, chartLegend} = this.state;

        this.props.buildChart(this.props.courseId, chartType, this.state.dateRange, this.props.user.id);
        this.setState({chartLegend: true});
        /*
        let chapterLength = 0;

        chart = [];

        course.CourseSubject.map(sub => {
            if(sub.CourseChapter.length > chapterLength){
                chapterLength = sub.CourseChapter.length;
            }
        })

        if(chartType === 'main'){

            chartX = course.CourseSubject.map(s => s.name);
            chartLegend = true;


            let count = 0;

            chart = [{
                colorByPoint: true,
                data: []}];


            course.CourseSubject.map((sub, i) => {
                let chapterData = {
                    name: sub.name,
                    stack: count,
                    data: [],
                    _colorIndex: count
                }
                if (this.state.chartSubject) {
                    if (sub.id !== this.state.chartSubject.id) {
                        return false;
                    }
                } else {

                    let scores = [];
                    let scoreSum = 0;


                    sub.CourseChapter.map(p => {

                        sub.CourseChapter.map(p => {
                            if(p.type === "test"){
                                p.UserTest.map(test => {
                                    let testDate = moment(new Date(test.createdAt));
                                    let daysSince = moment().diff(testDate, 'days');
                                    if(daysSince <= this.state.dateRange) {


                                        scores.push(test.correctPercent);
                                        scoreSum += test.correctPercent;
                                    }

                                })
                            }else {
                                p.ChapterVideo.map(v => {
                                    chapterData.name = p.name;

                                    v.ChapterTest.map(test => {
                                        let testDate = moment(new Date(test.createdAt));
                                        let daysSince = moment().diff(testDate, 'days');
                                        if(daysSince <= this.state.dateRange) {
                                            scores.push(test.correctPercent);
                                            scoreSum += test.correctPercent;
                                        }
                                    })

                                })
                            }


                        });


                    });


                    let average = parseInt(scoreSum / scores.length);
                    chart[0]['data'][i] = average;
                    chart[0]['name'] = "Average";
                    //chapterData['data'].push(average);
                    //chart.push(chapterData);


                }
            })



        } else if(chartType === 'quiz'){

            chartX = course.CourseSubject.map(s => s.name);

            course.CourseSubject.map(subject => {
                let midLength = 0;
                subject.CourseChapter.filter(c => c.type !== 'test').map(chapter => {
                    midLength = chapter.ChapterVideo.filter(v => v.QuizQuestions.length != 0).length;
                    if(chapterLength < midLength){
                        chapterLength = midLength;
                    }
                })
            })

            // subject 1 first quiz, subject 2, first quix
            // subject 1 second quiz, subject 2 second quiz

            chart = [
                {data: [100, 2, 3, 4]},
                {data: [100, 5, 4, 3]},
                {data: [80, 5, 4, 3]}
            ]

            let data = [];

            let chapterAdded = 0;
            while(chapterAdded < chapterLength){
                data.push({name: 'Average', data: []});
                chapterAdded++;
            }


            let subjectIndex = 0;
            while(subjectIndex < course.CourseSubject.length){
                course.CourseSubject[subjectIndex].CourseChapter.map(chapter => {
                    chapter.ChapterVideo.filter(v => v.QuizQuestions.length > 0).map((v, i) => {


                        let scores = [];
                        let scoreSum = 0;

                        v.ChapterTest.map(test => {
                            let testDate = moment(new Date(test.createdAt));
                            let daysSince = moment().diff(testDate, 'days');
                            if (daysSince <= this.state.dateRange) {
                                scores.push(test.correctPercent);
                                scoreSum += test.correctPercent;
                            }
                        })

                        let average = parseInt(scoreSum / scores.length);
                        let d = {y: average, name: v.title, id: v.id};
                        data[i]['data'][subjectIndex] = d;
                    })
                })
                subjectIndex++;

            }

            chart = data;






        }else if(chartType === 'subject'){
            chartX = course.CourseSubject.map(s => s.name);
            chartLegend = true;


            let count = 0;

            chart = [{
                colorByPoint: true,
                data: []}];


                course.CourseSubject.map((sub, i) => {
                    let chapterData = {
                        name: sub.name,
                        stack: count,
                        data: [],
                        _colorIndex: count
                    }

                    let shouldPass = false;

                        if(this.state.chartSubject){
                            if (sub.id !== this.state.chartSubject.id) {
                                chartX = course.CourseSubject.filter(s => s.id === this.state.chartSubject.id).map(s => s.name);
                                shouldPass = true;
                            }
                        }

                        if(!shouldPass) {


                            let scores = [];
                            let scoreSum = 0;
                            sub.CourseChapter.filter(c => c.type === "test").map(p => {
                                chapterData.name = p.name;

                                p.UserTest.map(test => {
                                    let testDate = moment(new Date(test.createdAt));
                                    let daysSince = moment().diff(testDate, 'days');
                                    if (daysSince <= this.state.dateRange) {

                                        scores.push(test.correctPercent);
                                        scoreSum += test.correctPercent;
                                    }
                                })

                            });


                            let average = parseInt(scoreSum / scores.length);
                            chart[0]['data'][count] = average;
                            chart[0]['name'] = 'Average';
                            //chapterData['data'].push(average);
                            //chart.push(chapterData);
                            count++;
                        }


                })


            }







        this.setState({chart, chartX, chartLegend});
        */

    }

    componentWillReceiveProps(props){
        let {chart} = this.state;
        if(chart.length === 0 && props.course || props.courseId !== this.props.courseId){
            if(this.props.course){
                this.buildChart('main', props.course, '');
            }
        }
    }
    //Lifecycle
    componentDidMount() {
        if(this.props.usersStatus) {
            this.setState({
                displayColumns: [...this.props.usersStatus.columnsTable, {
                    title: 'Options',
                    render: this.renderOptions,
                    className: 'sorting_asc',
                    prop: 'options',
                    defaultChecked: true,
                    value: 17
                }].filter(item => item.defaultChecked),
                columnsTable: [...this.props.usersStatus.columnsTable, {
                    title: 'Options',
                    render: this.renderOptions,
                    className: 'sorting_asc',
                    prop: 'options',
                    defaultChecked: true,
                    value: 17
                }]
            });
        }
    };

    render() {
        const {usersStatus} = this.props;
        let {chart} = this.state;




        return (
            <div>
                <div className="panel customPanel">
                    <div className="panel-heading">
                        <div className="panel-control">
                            <div className="btn-group dropdown">
                                <a  className={`btn btn-danger btn-group shownMainChartBtn ${this.state.chartSubject ? '' : 'hidden'}`} onClick={(e) => {
                                    e.preventDefault();
                                    this.updateChartType('all', null)
                                }} ><i className="zmdi zmdi-arrow-back"></i></a>
                                <div className="dropdown btn-group">
                                    <a  className="btn btn-info" data-toggle="dropdown">Choose Subject</a>
                                    <ul className="dropdown-menu pull-right">

                                        {this.props.course ?
                                            this.props.course.CourseSubject.map(sub => {
                                                return (
                                                    <li><a  onClick={(e) => {
                                                        e.preventDefault();
                                                        this.updateChartType('subject', sub);
                                                    }}>{sub.name}</a> </li>
                                                )
                                            })
                                        : null}
                                    </ul>
                                </div>
                            </div>

                        </div>
                        <h3 className="panel-title"></h3>
                    </div>
                    <div className="panel-body no-padding">
                        <div className="sp-20">
                            <div className="row">
                                <div className="col-sm-5">
                                    <a  className={`btn ${(this.state.chartType === 'main') ? 'btn-danger' : 'btn-filter btn-default'}`} onClick={(e) => {
                                        e.preventDefault();
                                        this.updateChartType('main', null);
                                    }}>Class Average</a>
                                    <a  className={`btn ${(this.state.chartType === 'subject') ? 'btn-danger' : 'btn-filter btn-default'}`} onClick={(e) => {
                                        e.preventDefault();
                                        this.updateChartType('subject', null);
                                    }}>Subject Performance</a>
                                    <a  className={`btn ${(this.state.chartType === 'quiz') ? 'btn-danger' : 'btn-filter btn-default'}`} onClick={(e) => {
                                        e.preventDefault();
                                        this.updateChartType('quiz', null);
                                    }}>Quiz Performance</a>
                                </div>
                                <div className="col-sm-7">
                                    <div className="text-right">
                                        <a  className={`btn ${(this.state.dateRange === 365) ? 'btn-danger' : 'btn-filter btn-default'}`} onClick={(e) => {
                                            e.preventDefault();
                                            this.updateChartDate('12 Months');
                                        }}>12 Months</a>
                                        <a  className={`btn ${(this.state.dateRange === 183) ? 'btn-danger' : 'btn-filter btn-default'}`} onClick={(e) => {
                                            e.preventDefault();
                                            this.updateChartDate('6 Months');
                                        }}>6 Months</a>
                                        <a  className={`btn ${(this.state.dateRange === 90) ? 'btn-danger' : 'btn-filter btn-default'}`} onClick={(e) => {
                                            e.preventDefault();
                                            this.updateChartDate('3 Months');
                                        }}>3 Months</a>
                                        <a  className={`btn ${(this.state.dateRange === 30) ? 'btn-danger' : 'btn-filter btn-default'}`} onClick={(e) => {
                                            e.preventDefault();
                                            this.updateChartDate('1 Month');
                                        }}>1 Months</a>
                                        <a  className={`btn ${(this.state.dateRange === 15) ? 'btn-danger' : 'btn-filter btn-default'}`} onClick={(e) => {
                                            e.preventDefault();
                                            this.updateChartDate('15 Days');
                                        }}>15 Days</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            id="AvgScore"
                            className="wrap-statistic-diagram"
                        >
                            {this.props.chart ?
                            <ReactHighcharts
                                config={this.renderConfigHighchart(this.props.chart)}
                                ref="chart"
                            />
                            : null}
                        </div>
                    </div>
                </div>
                
                {this.state.showTestDetails &&
                    <div className="modal fade in show" id="SubjectQuestionGraph" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-body no-padding">
                                    <button
                                        type="button"
                                        className="bootbox-close-button close"
                                        data-dismiss="modal"
                                        aria-hidden="true"
                                        style={{padding: 10,
                                            padding: '10px',
                                            zIndex: 999999,
                                            display: 'block',
                                            color: '#fff',
                                            position: 'absolute',
                                            right: 0
                                        }}
                                        onClick={() => this.setState({showTestDetails: false})}
                                    >
                                        ×
                                    </button>
                                    <div className="sp-20 modal-head-graph">

                                        <h3 className="text-center sm-top20">Quiz Performance by Each Question</h3>
                                    </div>
                                    <div className="SubjectQuestionGraphWrapper">

                                        
                                        <div id="SubjectQuestionGraphContainer" style={{width: '100%', height: '400px'}}>
                                            
                                            <ReactHighcharts
                                                config={this.renderQuizHighchart(this.state.testChart)}
                                                ref="chart"
                                            />
                                        </div>
                                    </div>
                                </div>
    
                            </div>
                        </div>
                    </div>
                }



                <div className="sm-top100">
                    {this.props.courseId &&
                    <PeopleStudentsContainer courseId={this.props.courseId}/>
                    }
                </div>
            </div>
        );
    }
}

CourseStatistic.propTypes = {
    usersStatus: PropTypes.shape({
        columnsTable: PropTypes.array,
        dataTable: PropTypes.array,
        statisticDiagram: PropTypes.array
    })
};

export default CourseStatistic;


// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardAdmin/CourseStatistic.js